/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

class ListSelectWrapper extends React.Component {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.object),
    isOpen: PropTypes.bool,
    onChangeCallback: PropTypes.func,
    onCloseCallback: PropTypes.func,
    selectedItemId: PropTypes.string,
    searchable: PropTypes.bool,
    itemName: PropTypes.string,
  }

  static defaultProps = {
    options: [],
    isOpen: false,
    onChangeCallback: null,
    onCloseCallback: null,
    selectedItemId: '',
    searchable: false,
    itemName: 'Item',
  }

  constructor(props) {
    super(props);
    this.state = {
      didMount: false,
      searchText: '',
      highlightedItemId: 0,
    };
    this.setListSelectWrapperRef = this.setListSelectWrapperRef.bind(this);
    this.globalOnKeyDownHandle = this.globalOnKeyDownHandle.bind(this);
  }

  componentDidMount = () => {
    const self = this;
    this.setState({ didMount: true });
    // window.addEventListener('mousedown', this.globalOnClickHandle, false);
    window.addEventListener('keydown', this.globalOnKeyDownHandle, false);
    window.addEventListener('resize', () => {
      // This is just to refresht the control when window is resized
      // otherwise UI of dropdown gets distorted
      self.setState({ highlightedItemId: self.state.highlightedItemId });
    }, false);
  }

  componentDidUpdate = (prevProps) => {
    const { isOpen } = this.state;
    if (prevProps.isOpen && !!isOpen) {
      this.setState({ searchText: '' });
    }
    this.render();
  }

  onDropdownSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  }

  getDropdownOptions = () => {
    const { didMount } = this.state;
    const result = [];
    if (didMount) {
      const { options } = this.props;
      if (options.length) {
        return this.convertOptionsToHtml(options);
      }
    }
    return result;
  }

  setListSelectWrapperRef(node) {
    this.listSelectWrapperRef = node;
  }

  globalOnKeyDownHandle = (e) => {
    if (this.listSelectWrapperRef) {
      const { isOpen, options } = this.props;
      if (isOpen) {
        let { highlightedItemId } = this.state;
        const currentOption = options.find(si => si.props.value === highlightedItemId);
        const actionableKeyCodes = [13, 38, 40];
        if (actionableKeyCodes.includes(e.keyCode)) {
          if (currentOption) {
            const currentHighlightIndex = options.findIndex(si => si.props.value === highlightedItemId);
            if (e.keyCode === 38) {
              // up
              this.moveUpOneOption(options, currentHighlightIndex);
            } else if (e.keyCode === 40) {
              // down
              this.moveDownOneOption(options, currentHighlightIndex);
            }
          } else {
            this.setState({ highlightedItemId: options[0].props.value });
            highlightedItemId = options[0].props.value;
          }
          if (e.keyCode === 13) {
            this.simulateOptionClick(highlightedItemId);
          }
        }
      }
    }
  }

  moveDownOneOption = (options, currentIndex) => {
    if (currentIndex !== options.length - 1) {
      const option = options[currentIndex + 1];
      this.setState({ highlightedItemId: option.props.value });
      this.scrollTo(option, false);
    }
  }

  moveUpOneOption = (options, currentIndex) => {
    if (currentIndex !== 0) {
      const option = options[currentIndex - 1];
      this.setState({ highlightedItemId: option.props.value });
      this.scrollTo(option, true);
    }
  }

  handleOptionClick = (e) => {
    const { itemId } = e.target.dataset;
    if (itemId) {
      this.changeSelectedOrg(itemId);
    }
    e.stopPropagation();
  }

  handleOptionMouseOver = (e) => {
    const { highlightedItemId } = this.state;
    const { itemId } = e.target.dataset;
    if (itemId !== highlightedItemId) {
      this.setState({ highlightedItemId: itemId });
    }
  }

  handleOptionMouseOut = () => {
    this.setState({ highlightedItemId: '' });
  }

  scrollTo = (option, up = true) => {
    if (this.listSelectWrapperRef) {
      const dropdownOptions = this.listSelectWrapperRef;
      const dropdownItem = document.querySelector(`[data-item-id="${option.props.value}"]`);
      const optionsOffset = dropdownOptions.offsetTop;
      const itemOffset = dropdownItem.offsetTop;
      const optionsHeight = dropdownOptions.offsetHeight;
      const diff = itemOffset - optionsOffset - optionsHeight;
      const itemHeight = dropdownItem.offsetHeight;
      const currentScrollTop = dropdownOptions.scrollTop;
      if (!up && diff > -30) {
        this.listSelectWrapperRef.scrollTop = (currentScrollTop + diff + itemHeight);
      } else if (up && (diff + optionsHeight) >= -30 && (diff + optionsHeight) <= 0) {
        this.listSelectWrapperRef.scrollTop = (currentScrollTop + diff + optionsHeight);
      }
    }
  }

  changeSelectedOrg(orgId) {
    const { onChangeCallback, onCloseCallback } = this.props;
    if (onChangeCallback) {
      onChangeCallback(orgId);
    }
    if (onCloseCallback) {
      onCloseCallback();
    }
  }

  simulateOptionClick(optionId) {
    const { selectedItemId } = this.props;
    if (optionId !== selectedItemId) {
      this.changeSelectedOrg(optionId);
    }
  }

  containsSearchText(text) {
    const { searchText } = this.state;
    if (!searchText?.length) {
      return false;
    }
    const searchTextTrimmed = searchText.toLowerCase().trim();
    return text.toLowerCase().includes(searchTextTrimmed);
  }

  convertOptionToHtml(option) {
    const { selectedItemId, searchable } = this.props;
    const { highlightedItemId, searchText } = this.state;
    if (searchable && !!searchText?.length && !this.containsSearchText(option.children)) {
      return null;
    }

    const image = option.img ? <img src={option.img} alt="" /> : '';
    let optionClass = `${styles.truncateText} ${styles.dropdownItem}`;
    if (option.value === selectedItemId || option.value === highlightedItemId) {
      optionClass += ` ${styles.highlightItem}`;
    }
    if (option.className && option.className.length) {
      optionClass += ` ${option.className}`;
    }
    const handleClick = option.onClick || this.handleOptionClick;

    return (
      <li
        className={optionClass}
        key={option.value || option.label}
        data-item-id={option.value}
        onBlur={this.handleOptionMouseOut}
        onMouseOut={this.handleOptionMouseOut}
        onMouseOver={this.handleOptionMouseOver}
        onFocus={this.handleOptionMouseOver}
        onClick={handleClick}
        style={option.styles || null}
      >
        {image}
        {option.children}
      </li>
    );
  }

  convertOptGroupToHtml(optgroup) {
    const options = [];
    const { label, children } = optgroup;
    const optGroupLabel = <strong className={styles.itemGroup}>{label}</strong>;
    for (let i = 0; i < children.length; i += 1) {
      const option = children[i];
      const optionHtml = this.convertOptionToHtml(option.props);
      if (optionHtml) {
        options.push(optionHtml);
      }
    }
    if (options.length) {
      const groupClasses = `${styles.dropdownGroup} ${styles.dropdownItem}`;
      const optionsGroup = <ul className={styles.dropdownNestedItems}>{options.map(opt => opt)}</ul>;
      return (
        <li className={groupClasses} key={label}>
          {optGroupLabel}
          {optionsGroup}
        </li>
      );
    }
    return null;
  }


  convertOptionsToHtml(options) {
    const result = [];
    if (options.length) {
      for (let i = 0; i < options.length; i += 1) {
        const option = options[i];
        if (option.type === 'option') {
          result.push(this.convertOptionToHtml(option.props));
        } else if (option.type === 'optgroup') {
          result.push(this.convertOptGroupToHtml(option.props));
        }
      }
    }
    return result;
  }

  render() {
    const { didMount, searchText } = this.state;
    const { isOpen, searchable, itemName } = this.props;
    let dropdownOptions = [];
    if (didMount) {
      if (isOpen) {
        dropdownOptions = this.getDropdownOptions();
      }
    }
    return (
      <div className={`${styles.dropdownContainer} ${searchable ? styles.searchableDropdown : ''}`}>
        {searchable && (
          <input
            id="orgSearchInput"
            className={styles.searchInput}
            placeholder={`Search ${itemName}s`}
            maxLength={100}
            defaultValue=""
            value={searchText}
            onChange={this.onDropdownSearchChange}
          />
        )}
        <span
          ref={this.setListSelectWrapperRef}
          className={styles.dropdownOptions}
          onKeyDown={this.handleKeyDown}
          role="listbox"
          tabIndex={-1}
        >
          {dropdownOptions.length ? dropdownOptions
            : (
              <span key={-1} style={{ marginLeft: '10px' }}>
                {`No matching ${itemName}s found.`}
              </span>
            )}
        </span>
      </div>
    );
  }
}

export default ListSelectWrapper;
